import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Check, X } from 'lucide-react';

export default function Footer() {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="bg-[#2A1E17] text-[#E6D8C8]"
    >
      <div className="section-container py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3 className="font-['Cormorant_Garamond'] text-3xl font-medium text-[#FBF9F6] mb-4">
              Rui's Restaurante
            </h3>
            <p className="text-sm text-[#E6D8C8]/80 mb-4">
              Steakhouse, Italian & Carvery
            </p>
            <p className="text-xs text-[#8C5A2B]">Since 1991</p>
          </div>

          {/* Accessibility */}
          <div>
            <h4 className="font-medium text-[#FBF9F6] mb-4 uppercase tracking-wider text-sm">
              {t('footer.accessibility')}
            </h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <Check size={14} className="text-[#8C5A2B]" />
                {t('footer.wheelchairEntrance')}
              </li>
              <li className="flex items-center gap-2">
                <Check size={14} className="text-[#8C5A2B]" />
                {t('footer.wheelchairSeating')}
              </li>
              <li className="flex items-center gap-2 text-[#E6D8C8]/50">
                <X size={14} />
                Assistive hearing loop
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-medium text-[#FBF9F6] mb-4 uppercase tracking-wider text-sm">
              {t('footer.services')}
            </h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <Check size={14} className="text-[#8C5A2B]" />
                {t('footer.outdoorSeating')}
              </li>
              <li className="flex items-center gap-2">
                <Check size={14} className="text-[#8C5A2B]" />
                {t('footer.delivery')}
              </li>
              <li className="flex items-center gap-2">
                <Check size={14} className="text-[#8C5A2B]" />
                {t('footer.dineIn')}
              </li>
            </ul>
          </div>

          {/* Payments */}
          <div>
            <h4 className="font-medium text-[#FBF9F6] mb-4 uppercase tracking-wider text-sm">
              {t('footer.payments')}
            </h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <Check size={14} className="text-[#8C5A2B]" />
                {t('footer.creditCards')}
              </li>
              <li className="flex items-center gap-2">
                <Check size={14} className="text-[#8C5A2B]" />
                {t('footer.nfc')}
              </li>
              <li className="flex items-center gap-2">
                <Check size={14} className="text-[#8C5A2B]" />
                {t('footer.cash')}
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#3A2E27] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-[#E6D8C8]/60">
            © {currentYear} Rui's Restaurante. {t('footer.rights')}
          </p>
          <div className="flex items-center gap-6 text-sm text-[#E6D8C8]/60">
            <a href="tel:+351932815611" className="hover:text-[#8C5A2B] transition-colors">
              +351 932 815 611
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
